const quickAddButton = {
    QuickAddButton: {
        baseStyle: ({listingLayout}: {listingLayout: string}) => ({
            wrapper: {
                display: listingLayout === 'grid3' ? {base: 'none', xl: 'flex'} : 'flex',
                pr: listingLayout === 'carousel' ? '0' : {base: 'spacing.5', sm: 'spacing.1'},
            },
        }),
    },
}

export default quickAddButton
